import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.get({
      url: '/admin/c2c/orders',
      data
    });
  },
  approveAudit(data) {
    return http.post({
      url: '/admin/c2c/audit',
      data,
      dataType: 'form'
    });
  },
  cancelAudit(id) {
    return http.post({
      url: '/admin/c2c/cancel',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  getBillList(data) {
    return http.get({
      url: '/admin/c2c/billList',
      data
    });
  },
  getUserRecords(data) {
    return http.get({
      url: '/admin/workorder/findByUse/Forward',
      data: {
        useId: data.userId,
        page: data.page,
        size: data.size
      }
    });
  },
  getUserWallet(id) {
    return http.get({
      url: '/admin/workorder/findByUse/wallet',
      data: {
        userId: id
      }
    });
  }
};
